import { render, staticRenderFns } from "./OrderProductSelectionPage.vue?vue&type=template&id=4ab96ac3&scoped=true&"
import script from "./OrderProductSelectionPage.vue?vue&type=script&lang=js&"
export * from "./OrderProductSelectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab96ac3",
  null
  
)

export default component.exports